import { FeatureFlag } from '../FeatureFlag';

/**
 * Reserved rollout flag for client-stitched risk tables (ADR 0020, DEC-ROLLOUT-001): Positions,
 * Orders, Executions, Accounts, and the aggregated risk widgets. Nothing reads it yet. Their rows
 * are risk entities rather than symbols, and stitching them waits on a way to request a column
 * table for a list of entity keys (OD-RISK-001).
 */
export const enableStitchedRiskTables = new FeatureFlag({
    key: 'enable-stitched-risk-tables',
    defaultValue: false,
});
